import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Button } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import {
	DataGridPremium,
	GRID_AGGREGATION_ROOT_FOOTER_ROW_ID,
	GridActionsCellItem,
	GridToolbar
} from "@mui/x-data-grid-premium";
import dayjs from "dayjs";
import React, { useMemo } from 'react';
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import PageMenu from "../../../components/custom/app/pageMenu/pageMenu";
import PageContentWrapper from "../../../components/mui/app/pageContentWrapper/pageContentWrapper";
import PageTitle from "../../../components/mui/app/pageTitle/pageTitle";
import QuickView from "../../../components/mui/general/quickView/quickView";
import { CustomPagination } from "../../../components/mui/grids/dataGridCustom/customPagination";
import DataGridWrapper from "../../../components/mui/grids/dataGridWrapper/dataGridWrapper";
import { muiGridLocales } from "../../../helpers/muiGridLocales";
import { access_user, view_mails } from "../../../helpers/rights";
import { getRouteUrl } from "../../../helpers/routing/getRouteUrl";
import { useMuiGridServerSide } from "../../../hooks/muiGrid/useMuiGridServerSide";
import useUserData from "../../../hooks/user/useUserData";
import { withPermissionHOC } from "../../permission/components/permissionHOC/permissionHOC";
import QuickDetailsUser from "../../users/Components/QuickDetails/QuickDetailsUser";
import { ROUTE_PAGE_USERS_DETAILS, ROUTE_PAGE_USERS_EDIT } from "../../users/routes/routes";
import { MAILS } from "../locales/namespaces";
import { ROUTE_MAILS_DETAILS } from "../routes/routes";


const Index = () => {
	const {t} = useTranslation(MAILS)
	
	
	const {
		isLoading,
		data,
		total,
		page,
		pageSize,
		onPaginationModelChange,
		onSortModelChange,
		onFilterModelChange
	} = useMuiGridServerSide({
		url: 'pde/indexTable/mails',
		initialPageSize: 50,
		initialSortModel: [{ name: 'id', direction: 'descending' }]
	})
	const { language } = useUserData()
	const columns = useMemo(() => {
		return [
			// {
			// 	headerName: t('Actions'),
			// 	field: 'actions',
			// 	type: 'actions',
			// 	getActions: (params) => {
			// 		if (params.id === GRID_AGGREGATION_ROOT_FOOTER_ROW_ID) {
			// 			return []
			// 		}
			// 		return [
			// 			<GridActionsCellItem
			// 				component={Link}
			// 				to={getRouteUrl(ROUTE_PAGE_USERS_EDIT, { id: params.id })}
			// 				icon={
			// 					<Tooltip title={t('Edit')}>
			// 						<IconButton>
			// 							<EditIcon/>
			// 						</IconButton>
			// 					</Tooltip>
			// 				}
			// 				color={'info'}
			// 				label={t('Edit')}>
			// 			</GridActionsCellItem>
			// 		]
			// 	}
			// },
			
			{
				field: 'SendTo',
				headerName: t('Send to'),
				minWidth: 150,
				flex: 1,
			},
			{
				field: 'Subject',
				headerName: t('Subject'),
				minWidth: 150,
				flex: 1,
				renderCell: ({ row }) => (
					<Link to={getRouteUrl(ROUTE_MAILS_DETAILS, {
						id: row.id
					})}>
						{row.Subject}
					</Link>
				)
			},
			{
				field: 'Body',
				headerName: t('Body'),
				minWidth: 180,
				flex: 1,
			},
			{
				field: 'Date',
				headerName: t('Date'),
				minWidth: 150, flex: 1,
				valueFormatter: (value, row, column, apiRef) => {
					return (value ? dayjs(value).format('DD/MM/YYYY') : null)
				}
			}
		]
	}, [t])
	return (
		// <div>
		// 	hello!!! mails are here!!!
		// </div>
		<Box className={'mails_index'} sx={{marginTop:'10px'}}>

			<PageContentWrapper>
				<PageTitle
					title={t('Mails')}/>
				<DataGridWrapper sx={{ height: 700 }}>
					<DataGridPremium
						columns={columns}
						initialState={{ density: "compact" }}
						rows={data}
						pagination
						paginationModel={{ page, pageSize }}
						paginationMode="server"
						onPaginationModelChange={onPaginationModelChange}
						rowCount={Number(total)}
						pageSizeOptions={[5, 10, 15, 20, 50, 100]}
						sortingMode="server"
						onSortModelChange={(sortModel) => onSortModelChange(sortModel)}
						filterMode="server"
						onFilterModelChange={onFilterModelChange}
						loading={isLoading}
						localeText={muiGridLocales(language)}
						slots={{
							pagination: CustomPagination,
							toolbar: GridToolbar,
						}}
					/>
				</DataGridWrapper>
			</PageContentWrapper>
		</Box>
	);
};

// export default Index
export default withPermissionHOC(Index, [view_mails])